import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export function SetPasswordDialog({ open, onOpenChange }) {
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const { refresh } = useAuth();
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/set-password", { password: pw });
      toast.success("Password saved. You can now sign in with email and password.");
      setPw(""); refresh(); onOpenChange(false);
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="set-password-dialog">
        <DialogHeader>
          <DialogTitle>Set a password</DialogTitle>
          <DialogDescription>Optional. You can always sign in with an emailed link instead.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="new-pw">New password (min 8 characters)</Label>
            <Input id="new-pw" type="password" minLength={8} required value={pw} onChange={(e) => setPw(e.target.value)} data-testid="set-password-input" />
          </div>
          <Button type="submit" disabled={busy} className="rounded-full w-full" data-testid="set-password-submit">Save password</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
